import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function generateFaqs(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/generate_faqs`)
}
export function getContentFaq(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/content_faq`)
}
export function approveFaqs(pageId, questions = null) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_faqs`, { questions })
}
export function approveFaqCorrections(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_faq_corrections`)
}
export function generateFaqSchema(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/generate_faq_schema`)
}
